<template>
  <div class="local-filter-select">
    <van-field
      :label="label"
      label-width="100px"
      v-model="selectedText"
      :placeholder="placeholder"
      readonly
      clickable
      :error-message="errMsg"
      @click="showPicker = true"
      right-icon="arrow-down"
      style="margin-left: -20px;"
    />

    <!-- 下拉弹出层 -->
    <van-popup
      v-model="showPicker"
      round
      position="bottom"
      :style="{ height: '50%' }"
    >
      <div class="popup-content">
        <!-- 搜索框 -->
        <div class="search-section">
          <van-search
            v-model="searchText"
            placeholder="请输入车次搜索"
            @update:model-value="handleSearch"
            clearable
          />
        </div>

        <!-- 选项列表 -->
        <div class="options-list">
          <van-picker
            show-toolbar
            :columns="filteredOptions"
            @confirm="onConfirm"
            @cancel="onCancel"
            value-key="text"
          />
        </div>

        <!-- 无结果提示 -->
        <div v-if="filteredOptions.length === 0" class="empty-state">
          未找到匹配的选项
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: 'LocalFilterSelect',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    // 双向绑定的值
    value: {
      type: [String, Number],
      default: ''
    },
    // 选项数据
    options: {
      type: Array,
      default: () => []
    },
    // 标签文本
    label: {
      type: String,
      default: '选择项目'
    },
    // 占位符
    placeholder: {
      type: String,
      default: '请选择'
    }
  },
  data() {
    return {
      errMsg: '',
      showPicker: false,
      searchText: '',
      selectedText: '',
      selectedValue: this.value
    };
  },
  computed: {
    // 过滤后的选项列表
    filteredOptions() {
      if (!this.searchText.trim()) {
        return this.options;
      }
      
      const keyword = this.searchText.trim().toLowerCase();
      return this.options.filter(item => 
        item.text.toLowerCase().includes(keyword) || 
        (item.value && item.value.toString().toLowerCase().includes(keyword))
      );
    }
  },
  watch: {
    // 监听外部传入的value值变化
    value(newVal) {
      this.selectedValue = newVal;
      this.updateSelectedText();
    },
    // 监听选项数据变化，更新显示文本
    options: {
      handler() {
        this.updateSelectedText();
      },
      deep: true
    }
  },
  mounted() {
    this.updateSelectedText();
  },
  methods: {
    // 处理搜索输入
    handleSearch(value) {
      this.searchText = value;
      this.errMsg = '';
    },
    
    // 确认选择
    onConfirm(value) {
      this.selectedValue = value.value;
      this.selectedText = value.train_number;
      this.showPicker = false;
      this.searchText = ''; // 清空搜索条件
      this.errMsg = '';
      
      // 触发change事件，实现v-model双向绑定
      this.$emit('change', value.value);
      // 同时传递完整的选择信息
      this.$emit('select', {
        value: value.value,
        text: value.text,
        rawData: value
      });
    },
    
    // 取消选择
    onCancel() {
      this.showPicker = false;
      this.searchText = '';
    },
    
    // 更新选中项的显示文本
    updateSelectedText() {
      if (!this.selectedValue || this.options.length === 0) {
        this.selectedText = '';
        this.errMsg = '车次不能为空';
        return;
      }
      const selectedItem = this.options.find(
        item => item.value === this.selectedValue
      );
      
      if (selectedItem) {
        this.selectedText = selectedItem.train_number;
        this.errMsg = '';
      } else {
        this.selectedText = '';
        this.errMsg = '车次不能为空';
      }
    }
  }
};
</script>

<style scoped>
.local-filter-select {
  width: 100%;
}

.popup-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.search-section {
  padding: 10px;
  border-bottom: 1px solid #f0f0f0;
}

.options-list {
  flex: 1;
  overflow: hidden;
}

.empty-state {
  text-align: center;
  color: #969799;
  font-size: 14px;
}

/* 自定义选项样式 */
:deep(.van-picker__option) {
  text-align: left;
  padding: 10px 16px;
}

:deep(.van-picker__option--selected) {
  color: #1989fa;
  font-weight: 500;
}
</style>